import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FirstPageService {
  private _test: boolean = false;

  constructor() { }

  public get test() {
    return this._test
  }

  public set test(new_test: boolean) {
    this._test = new_test
  }
}
